import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

/**
 * Fetch conformity document details by prescription ID
 * @param {string|number} prescriptionId - The prescription ID
 * @returns {Promise<Object>} - The conformity document details including download_url
 * @throws {Error} - Throws error if document not found (404) or other API errors
 */
export async function fetch(prescriptionId) {
  const axios = axiosInstanceWithoutLoader().primoLab;

  try {
    const response = await axios.get(`/conformity-documents/${prescriptionId}`);
    
    return {
      document: response.data.data || response.data,
      success: true
    };
  } catch (error) {
    if (error.response?.status === 404) {
      return {
        document: null,
        success: false,
        notFound: true,
        message: error.response?.data?.message || 'Dichiarazione del fabbricante non trovata'
      };
    }
    
    const errorMessages = error.response?.data?.errors || ['Si è verificato un errore nel recupero del documento'];
    throw new Error(errorMessages.join(', '));
  }
}